export function itineraryGridComp() {
    const $grids = document.querySelectorAll('.itinerary-grid');
    const fadeMs = 300;

    $grids?.forEach($grid => {
        const $taxBtns = $grid.querySelectorAll('.itinerary-grid__controls .taxonomy-btn');
        let isAnimating = false;

        $taxBtns?.forEach($btn => {
            $btn.addEventListener('click', handleBtnClick);
        });

        function handleBtnClick(e) {
            e.preventDefault();

            const $btn = e.currentTarget;
            if ( isAnimating || 'true' === $btn.getAttribute('aria-selected') ) return;

            const $target = document.getElementById($btn.getAttribute('aria-controls'));
            const $current = $grid.querySelector('.itinerary-grid__group.active');

            if ( !$target || $target === $current ) return;

            isAnimating = true;

            $taxBtns.forEach($taxBtn => {
                $taxBtn.setAttribute('aria-selected', $taxBtn === $btn ? 'true' : 'false');
            });

            const showTarget = () => {
                $target.classList.add('is-fading');
                $target.offsetHeight;
                $target.classList.add('active');

                window.setTimeout(() => {
                    $target.classList.remove('is-fading');
                    isAnimating = false;
                }, fadeMs);
            };

            if ( !$current ) {
                showTarget();
                return;
            }

            $current.classList.add('is-fading');
            $current.classList.remove('active');

            window.setTimeout(() => {
                $current.classList.remove('is-fading');
                showTarget();
            }, fadeMs);
        }
    });
}
